var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.$emit('give-pdf-pass')}}},[_c('img',{staticClass:"icon-pdf",attrs:{"src":_vm.iconPath('v_print.svg'),"alt":""}}),_vm._v(" "+_vm._s(this.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }